module.exports = __webpack_public_path__ + "media/images/fm_13-741354464444cb2f19afd3504d3c6105.jpg";